import {
  NavigateFunction,
  useNavigate as routerUseNavigate
} from "react-router-dom";
import { LEVEL } from "../consts";
import type {
  LearningObject, Level, ReferencedLearningActivity
} from "../types";

export function useNavigate() {
  type ExtendedNavigateFunction =
  NavigateFunction & {
    getWatchLink: typeof getWatchLink
    getDetailLink: typeof getDetailLink
    toDetail: typeof navigateToDetail
    toWatch: typeof navigateToWatch
    navigateToDetail: typeof navigateToDetail
  }
  type OptionalExtendedNavigateFunction =
    & NavigateFunction
    & Partial<Pick<ExtendedNavigateFunction, "getWatchLink" | "toDetail" | "toWatch" | "getDetailLink" | "navigateToDetail">>;

  const navigate: OptionalExtendedNavigateFunction = routerUseNavigate();
  navigate.getWatchLink = getWatchLink;
  navigate.getDetailLink = getDetailLink;
  navigate.toDetail = navigateToDetail;
  navigate.toWatch = navigateToWatch;
  navigate.navigateToDetail = navigateToDetail;


  function getWatchLink({
    isForYou = false,
    id,
    learningObjectTypology,
    courseId,
    rootId
  }: {
    isForYou?: boolean,
    id: Pick<LearningObject, "id"> | number,
    learningObjectTypology: Pick<LearningObject, "learningObjectTypology"> | Pick<ReferencedLearningActivity, "learningObjectTypology"> | Level,
    courseId?: number,
    rootId?: number
  }) {
    return `/${isForYou ? "per-te" : "esplora"}/guarda/${id}${(courseId && (id !== courseId) && learningObjectTypology !== LEVEL.COURSE ) ? ("/course/" + courseId) : ""}${(rootId && (id !== rootId) && learningObjectTypology !== LEVEL.PATH ) ? ("/root/" + rootId) : ""}/${learningObjectTypology}`;
  }

  function getDetailLink({
    isForYou = false,
    id,
    learningObjectTypology,
    courseId,
    rootId
  }: {
    isForYou?: boolean,
    id: Pick<LearningObject, "id"> | number,
    learningObjectTypology: Pick<LearningObject, "learningObjectTypology"> | Pick<ReferencedLearningActivity, "learningObjectTypology"> | Level,
    courseId?: number,
    rootId?: number
  }) {
    return `/${isForYou ? "per-te" : "esplora"}/dettaglio/${id}${(courseId && (id !== courseId) && learningObjectTypology !== LEVEL.COURSE ) ? ("/course/" + courseId) : ""}${(rootId && (id !== rootId) && learningObjectTypology !== LEVEL.PATH ) ? ("/root/" + rootId) : ""}/${learningObjectTypology}`;
  }

  function navigateToWatch({
    isForYou = false,
    id,
    learningObjectTypology,
    courseId,
    rootId
  }: {
    isForYou?: boolean,
    id: Pick<LearningObject, "id"> | number,
    learningObjectTypology: Pick<LearningObject, "learningObjectTypology"> | Pick<ReferencedLearningActivity, "learningObjectTypology"> | Level,
    courseId?: number,
    rootId?: number
  }) {
    navigate(getWatchLink({ isForYou, id, learningObjectTypology, courseId: courseId, rootId }));
  }

  function navigateToDetail({
    isForYou = false,
    id,
    learningObjectTypology,
    courseId,
    rootId
  }: {
    isForYou?: boolean,
    id: Pick<LearningObject, "id"> | number,
    learningObjectTypology: Pick<LearningObject, "learningObjectTypology"> | Pick<ReferencedLearningActivity, "learningObjectTypology"> | Level,
    courseId?: number,
    rootId?: number
  }) {
    navigate(getDetailLink({ isForYou, id, learningObjectTypology, courseId: courseId, rootId }));
  }

  return navigate as ExtendedNavigateFunction;
}

